import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=1c93cd58&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=ts"
export * from "./Pagination.vue?vue&type=script&lang=ts"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=1c93cd58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c93cd58",
  null
  
)

export default component.exports